<template>
    <div class="card card-custom gutter-b">
        <div class="card-body">
            <div class="card card-custom bg-light-success">
                <div class="card-header border-0">
                    <div class="card-title">
                        <span class="card-icon"><i class="flaticon2-chat-1 text-primary"></i></span>
                        <h3 class="card-label text-primary">Фильтр реактивный</h3>
                    </div>
                    <div class="card-toolbar"></div>
                </div>
                <div class="separator separator-solid separator-white opacity-20"></div>
                <div class="card-body text-primary">
                    <!-- <VueSelectHtml
                        :idSelect="employeeSelect" 
                        :selected="employee" 
                        :optionsList="employeeOptions" 
                    ></VueSelectHtml> -->
                    <div class="form-group row">
                        <label class="col-form-label col-sm-4 text-lg-right text-left">Сотрудник</label>
                        <div class="col-sm-8">
                            <select v-model="employee" class="form-control" @change="setEmployee()">
                                <option :value="item.value" v-for="item in employeeOptionsList" :key="item.value">{{ item.label }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card card-custom gutter-b" v-if="works">
        <div class="card-body">
            <!-- <TransitionGroup name="slide-right" > -->
            <TransitionGroup name="color" >
            <div class="alert alert-custom alert-outline-2x alert-outline-primary fade show mb-5" role="alert" v-for="work, index in works" :key="index">
                <div>{{ work.order?.id??'-' }}: Заказ <strong>#{{ work.order?.number??'-' }}</strong> от: {{ work.order?.created_at??'----' }}</div>
            </div>
            </TransitionGroup>
        </div>
    </div>
    <!-- <textarea style="width: 100%; min-height: 80px">{{ employees }}</textarea> -->
    <!-- <textarea style="width: 100%; min-height: 80px">{{ employeeOptions }}</textarea> -->
    <!-- <textarea style="width: 100%; min-height: 80px">{{ employeeOptionsList }}</textarea> -->
</template>

<script>
// import VueSelectHtml from '@/Components/VueSelectHtml.vue';

export default {
    // components: { VueSelectHtml },
    props: {
        employeeId: {type: Number, default: null},
        employees: {type: Object, default: null}
    },
    data() {
        return {
            token: null,

            employee: this.employeeId,
            works: null
        }
    },
    mounted(){
        this.token = document.querySelector("[name=csrf-token]").content;
        this.setEmployee();
    },
    computed: {
        employeeOptions: function(){
            let dol = [];
            // this.employees.forEach((v, k) => dol.push({label: v, value: k}));
            for (const [key, value] of Object.entries(this.employees)) {
                dol.push({label: value, text: value, value: key});
            }
            return dol;
        },
        // loadNext: function(){ return this.notifications.length < this.countNotifications; },
        // newNotifications: function(){
        //     let newN = 0;
        //     this.notifications.forEach(v => v.read == false ? newN++ : v);
        //     return newN;
        // },
        employeeOptionsList: function(){
            // return this.employeeOptions.sort((a, b) => { return a.label - b.label;});
            return this.employeeOptions.sort((a, b) => {
                if( a.label < b.label ){ return -1; }
                if( a.label > b.label ){ return 1; }
                return 0;
            });
        },
    },
    methods: {
        setEmployee(){
            let _this = this;
            if(this.employee){
                axios.post('/web-api/orders/works/' + this.employee, 
                    { headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': this.token
                    }}
                )
                .then(function(res){
                    console.log(res.data);
                    if(res.data.status == true){
                        _this.works = res.data.data;
                    } else {
                        window.getAlert('error', 'Ошибка', res.data.message)
                    }
                })
                .catch(function(error){
                    console.log(error);
                    window.$func.exceptionsHandler(error);
                });
            } else {
                _this.works = null;
            }
        },

    }
}
</script>